export default __webpack_public_path__ + "static/media/lineicons.297da061.svg";